import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import toastr from "toastr";
import logodark from "../../assets/images/logo.svg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";

const AuthLockScreen = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [username, setUsername] = useState("User");

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    document.body.classList.add("auth-body-bg");
    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, []);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("authUser");
      if (stored) {
        const parsed = JSON.parse(stored);
        const email = parsed?.user?.email || "";
        setUserEmail(email);
        const uname = email.split("@")[0];
        setUsername(uname.charAt(0).toUpperCase() + uname.slice(1));
      }
    } catch (err) {
      console.error("Failed to get auth user", err);
    }
  }, []);

  const verifyPassword = async (email, password) => {
    // Example logic — replace this with a real API POST call
    if (email === "superadmin@gmail.com" && password === "admin123") {
      return true;
    }
    return false;
  };

  const onSubmit = async (data) => {
    const isValid = await verifyPassword(userEmail, data.password);
    if (isValid) {
      toastr.success("Unlocked successfully!");
      localStorage.removeItem("isLocked");
      navigate("/dashboard");
    } else {
      toastr.error("Invalid password. Try again.");
    }
  };

  return (
    <React.Fragment>
      <div>
        <div className="container-fluid p-0">
          <div className="d-flex min-vh-100 justify-content-center align-items-center flex-column py-5">
            <div className="auth-header">
              <Link to="/" className="">
                <img src={logodark} alt="" height="32" className="auth-logo logo-dark mx-auto" />
              </Link>
            </div>
            <div className="card login_auth_block rounded-4">
              <div className="row g-0">
                <div className="col-lg-12">
                  <div className="authentication-page-content p-4 d-flex align-items-center ">
                    <div className="w-100">
                      <div className="row justify-content-center">
                        <div className="col-lg-11">
                          <div>
                            <div className="text-center pt-5">
                              <h4 className="font-size-30 fw-semibold mt-4">Lock screen</h4>
                              <p className="font-size-18 text-gray-600 mt-2">Enter your password to unlock the screen!</p>
                            </div>
                            <div className="p-2 mt-5">
                              <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
                                <div className="user-thumb text-center mb-5">
                                  <img
                                    src={avatar2}
                                    className="rounded-circle img-thumbnail avatar-md"
                                    alt="User Avatar"
                                  />
                                  <h5 className="font-size-15 mt-3">{username}</h5>
                                </div>
                                <div className="mb-3 auth-form-group-custom mb-4">
                                  <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                  <label htmlFor="userpassword">Password</label>
                                  <Controller
                                    name="password"
                                    control={control}
                                    rules={{ required: "Password is required" }}
                                    render={({ field }) => (
                                      <input
                                        {...field}
                                        type="password"
                                        id="userpassword"
                                        placeholder="Enter password"
                                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.password && (
                                    <span className="text-danger">{errors.password.message}</span>
                                  )}
                                </div>
                                <div className="mt-4 text-center">
                                  <button type="submit" className="btn btn-primary w-md">
                                    Unlock
                                  </button>
                                </div>
                              </form>
                            </div>
                            <div className="mt-5 text-center">
                              <p>
                                Not you? Return to{" "}
                                <Link to="/auth-login" className="fw-medium text-primary">
                                  Log in
                                </Link>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5 text-center auth-footer">
              <p>
                © 2021 ValSabji. Crafted with{" "}
                <i className="mdi mdi-heart text-danger"></i> by{" "}
                <Link to="https://www.valbeneti.com" target="_blank" rel="noreferrer">
                  ValBeneti Ltd
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AuthLockScreen;
